import React from 'react';

import { useForm, useFormState } from 'react-final-form';

import { ProjectVersionContext } from '@qality/common-components/src/lib/ProjectVersionProvider';
import { TestCyclesContext } from '@qality/common-components/src/lib/TestCyclesProvider';
import { IS_CLOUD } from '@qality/common-config/src/featureFlags';
import { CreateTestCycleDialogRenderer } from '@qality/server-renderers';

import { TestCyclesOverviewFiltersView } from './TestCyclesOverviewFilters.view';

export interface TestCyclesOverviewFiltersProps {}

const STATE_OPTIONS = [
  {
    label: 'All states',
    value: null,
  },
  {
    label: 'Closed',
    value: true,
  },
  {
    label: 'Open',
    value: false,
  },
];

export const TestCyclesOverviewFilters: React.FC<TestCyclesOverviewFiltersProps> =
  () => {
    const { change } = useForm();
    const { values } = useFormState();

    const {
      fetchProjectVersion,
      isFetchingProjectVersion,
      projectVersionList,
    } = React.useContext(ProjectVersionContext);

    const { isLoading } = React.useContext(TestCyclesContext);

    const handleSearchTestCycles = () => {
      change('pagination.page', 1);
      change('refreshCount', values.refreshCount + 1);
    };

    const handleOpenDialog = () => {
      if (IS_CLOUD) {
        window.AP.dialog.create({
          key: 'create-test-cycle-dialog',
          size: 'maximum',
          chrome: false,
        });
      } else {
        CreateTestCycleDialogRenderer.openCreateTestCycleDialog();
      }
    };

    React.useEffect(() => {
      if (values.project?.id) {
        fetchProjectVersion(values.project?.id);
      }
    }, [values.project?.id]);

    return (
      <TestCyclesOverviewFiltersView
        handleSearchTestCycles={handleSearchTestCycles}
        handleOpenDialog={handleOpenDialog}
        isLoading={isLoading}
        isFetchingProjectVersion={isFetchingProjectVersion}
        projectVersionList={[
          {
            name: 'No version',
            projectId: values.project?.id,
            id: '-1',
          },
        ].concat(projectVersionList || [])}
        isProjectSelected={values.project?.id}
        stateOptions={STATE_OPTIONS}
      />
    );
  };
